import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["successIcon", "source"]
  static values = {
    text: String,
    url: String,
    delay: { type: Number, default: 400 }
  }

  async copy(event) {
    const button = event.currentTarget

    button.classList.add("scale-95")
    setTimeout(() => button.classList.remove("scale-95"), 150)

    // ClipboardItem accepts a Promise blob, keeping the clipboard.write() call
    // synchronous within the click gesture. Safari blocks clipboard access if an
    // async operation (like fetch) runs before the write.
    const blob = this.hasSourceTarget
      ? Promise.resolve(new Blob([this.sourceTarget.value], { type: "text/plain" }))
      : this.hasUrlValue
        ? fetch(this.urlValue).then(r => r.blob())
        : Promise.resolve(new Blob([this.textValue], { type: "text/plain" }))

    await navigator.clipboard.write([new ClipboardItem({ "text/plain": blob })])
    this.#showSuccess(button)
  }

  #showSuccess(button) {
    if (!this.hasSuccessIconTarget) return

    const originalContent = button.innerHTML

    button.innerHTML = this.successIconTarget.innerHTML
    button.classList.add("btn-success")

    setTimeout(() => {
      // Skip .btn transition-colors while swapping markup/classes so we don't get a square
      // frame (rounded-full lost with btn-success) plus a fading green background.
      const previousTransition = button.style.transition
      button.style.transition = "none"
      button.innerHTML = originalContent
      button.classList.remove("btn-success")
      requestAnimationFrame(() => {
        button.style.transition = previousTransition
      })
    }, this.delayValue)
  }
}
